import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Dialog, Snackbar } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  fetchVoiceCallSession,
  fetchCandidateProfile,
  fetchVoiceAssistants,
  fetchAssessmentInviteDetails,
  fetchVideoCallDetails,
  clearCandidateSessionData,
  getPreScreeningReport,
  getVoiceSessionStatus,
  updateCandidateDetails,
  createShareLink,
  sendShareEmail,
} from "../../Redux/ActionCreators/candidateAction";
import {
  assignedStage,
  fetchAvailableSlots,
  fetchJobById,
} from "../../Redux/ActionCreators/jobsAction";
import './jobs.scss'
import moment from "moment";
import CircularProgressRing from "../../utils/CircularProgressRing";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import TimeZone from "../../utils/all_timezones.json";
import ApplyStageModal from "../../utils/applyStageModal";
import Lightbox from "../../utils/lightbox";
import CreatableSelect from "react-select/creatable";
import { fetchFlows, initiateOnboarding, uploadDocument, getRecruiterRunView, requestRunChanges, completeRunReview } from "../../Redux/ActionCreators/onboardingAction";
import { refreshRecruiterConversation, resetChat } from "../../Redux/ActionCreators/chatAction";
import PreScreeningStage from "../../utils/PreScreeningStage";
import VoiceInterviewStage from "../../utils/VoiceInterviewStage";
import AssessmentStage from "../../utils/AssessmentStage";
import VideoInterviewStage from "../../utils/VideoInterviewStage";

const StageIds = {
  Assessment: "293e9b95-4610-48f2-ae93-c7264cae7d6a",
  "Video Call": "ed658e02-1549-4d9e-a735-1f1c1e385f46",
  "Voice Call": "fd40e3d2-38a9-4cef-937a-93ef6a42d045",
};

const STATUS_COLORS = {
  COMPLETED: "#4CC948",
  EXPIRED: "#FF1C58",
  ASSIGNED: "#0048B7",
  UNASSIGNED: "#8A9199",
};

const HIRING_STATUS_IDS = {
  Hired: "a7db4d99-448f-4993-be64-e2000d499200",
  "Short Listed": "b4c604a1-7cb6-4e8d-8bd8-b4d7e92a8fbb",
  "On Hold": "a3f100dc-eedf-4965-82c2-84e3025dc35b",
  Rejected: "520f0726-efe2-4f5a-8ad4-81436a979663",
};

const buttonStyleMap = {
  Rejected: { border: "1px solid #FF1C58", background: "#FF1C581A" },
  "On Hold": { border: "1px solid #FFC857", background: "#FFC8571A" },
  "Short Listed": { border: "1px solid #00DDFF", background: "#00DDFF1A" },
  Hired: { border: "1px solid #4CC948", background: "#4CC9481A" },
};

// For mapping icon + label
const QUICK_ACTIONS = [
  {
    name: "Rejected",
    icon: "/images/cross-black.svg",
    width: 14,
    height: 14,
  },
  {
    name: "On Hold",
    icon: "/images/pause-black.svg",
    width: 14,
    height: 14,
  },
  {
    name: "Short Listed",
    icon: "/images/check-black.svg",
    width: 14,
    height: 14,
  },
  {
    name: "Hired",
    icon: "/images/hired-black.svg",
    width: 14,
    height: 14,
  },
];

const ALLOWED_REASSIGN_STATUSES = ["not scheduled", "failed", "expired", "revoked"];

const MOBILE_STAGES = [
  { label: "Pre-Screening", key: "Pre-Screening" },
  { label: "Telephonic Interview", key: "Voice Interview" },
  { label: "Assessments", key: "Assessments" },
  { label: "Video Interview", key: "Video Interview" },
];

const MOBILE_STAGE_TO_TESTTYPE = {
  "Pre-Screening": 0,
  "Voice Interview": 1,
  "Assessments": 2,
  "Video Interview": 3,
};

const normalizeStatus = (status) => (status || "").trim().toLowerCase();

const CandidateProfile = (props) => {
  const [showSummaryPopup, setShowSummaryPopup] = useState(false);
  const [loadingCall, setLoadingCall] = useState(false);
  const [showAssistantModal, setShowAssistantModal] = useState(false);
  const [assistants, setAssistants] = useState([]);
  const [selectedAssistantId, setSelectedAssistantId] = useState(null);
  const [currentAudio, setCurrentAudio] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tabLoading, setTabLoading] = useState(false);
  const [assessmentStatus, setAssessmentStatus] = useState("idle");
  const [showInlineReport, setShowInlineReport] = useState(false);
  const [inlineReportId, setInlineReportId] = useState(null);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [initiatingVideoCall, setInitiatingVideoCall] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackSeverity, setSnackSeverity] = useState("error");
  const [snackMessage, setSnackMessage] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  const [audioLoading, setAudioLoading] = useState(true);
  const [stageLoading, setStageLoading] = useState(false);
  const [scheduleDate, setScheduleDate] = useState(new Date());
  const [timezone, setTimezone] = useState(null);
  const [slotId, setSlotId] = useState(null);
  const [modalType, setModalType] = useState("");
  const [videoAgentType, setVideoAgentType] = useState("");
  const [expandSummary, setExpandSummary] = useState(false);
  const [expandRecommendation, setExpandRecommendation] = useState(false);
  const [showPhoneCheckModal, setShowPhoneCheckModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showScorePopup, setShowScorePopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupData, setPopupData] = useState([]);
  const [assignProgress, setAssignProgress] = useState({
    current: 0,
    total: 0,
  });
  const [refreshing, setRefreshing] = useState(false);
  const [showAllCheatingImages, setShowAllCheatingImages] = useState(false);
  const [openProctorLightbox, setOpenProctorLightbox] = useState(false);
  const [selectedProctorImage, setSelectedProctorImage] = useState("");
  const [selectedProctorIndex, setSelectedProctorIndex] = useState(null);
  const [statusLoading, setStatusLoading] = useState(false);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [shareEmails, setShareEmails] = useState([]);
  const [shareLoading, setShareLoading] = useState(false);
  const [shareData, setShareData] = useState(null);
  const [showAccessModal, setShowAccessModal] = useState(false);
  const [preselectStage, setPreselectStage] = useState(null);
  const [openMobileStage, setOpenMobileStage] = useState(null);
  const [onboardingModalOpen, setOnboardingModalOpen] = useState(false);
  const [onboardingFlows, setOnboardingFlows] = useState([]);
  const [onboardingForm, setOnboardingForm] = useState({ flowId: '', joiningDate: '' });
  const [onboardingLoading, setOnboardingLoading] = useState(false);
  const [onboardingAdditionalDocs, setOnboardingAdditionalDocs] = useState([]);
  const [onboardingFlowsLoading, setOnboardingFlowsLoading] = useState(false);
  const [dragActive, setDragActive] = useState(false);
  const [onboardingViewModal, setOnboardingViewModal] = useState({ open: false, runId: null, data: null, loading: false });
  const [onboardingCommentModal, setOnboardingCommentModal] = useState({ open: false, runId: null, value: '' });
  const [expandedOnboardingForms, setExpandedOnboardingForms] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const tooltipRef = useRef([]);
  const additionalDocInputRef = useRef(null);
  const flowSearchDebounceRef = useRef(null);
  const params = useParams();
  let jobId = params.jobId;
  let candidateId = params.candidateId;
  if (!jobId && props.jobId) jobId = props.jobId;
  if (!candidateId && props.candidateId) candidateId = props.candidateId;
  const isSharedReport = props.isSharedReport === true;
  const hideSensitive = props.hideSensitive === true;

  const isMobile = window.innerWidth < 767;

  const candidate = useSelector((state) => state.candidates.selectedCandidate);
  const videoSession = useSelector(
    (state) => state.candidates.videoSessionData,
  );
  const voiceSession = useSelector((state) => {
    const session = state.candidates.voiceSessionData;
    return session?.job_candidate_id === candidate?.id ? session : null;
  });
  const assessmentInviteDetails = useSelector(
    (state) => state.candidates.assessmentInviteDetails,
  );
  const latestJob = useSelector((state) => state.jobs.latestJob);

  const availableSlots = useSelector((state) => state.jobs.availableSlots);
  const chatConversation = useSelector((state) => state.chat.conversation);

  const preQualifyingReport = useSelector(
    (state) => state.candidates.preQualifyingReport,
  );

  const fromTab = location.state?.fromTab || "prescreening";

  const detectedTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // PROCTORING ANALYSIS
  let proctoring = videoSession?.result?.proctoring_analysis;
  let cheatingFrames = [];

  const selectedAssistant = assistants.find((a) => a.id === selectedAssistantId);

  if (proctoring?.samples?.length > 0) {
    cheatingFrames = proctoring.samples.filter(
      (s) => s?.llm_eval?.cheating_detected === true,
    );
  }

  const tabTypeMap = {
    prescreening: 0,
    voice: 1,
    assessment: 2,
    video: 3,
  };

  const [testType, setTestType] = useState(0);
  const [tabType, setTabType] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      if (!jobId || !candidateId) {
        setLoading(false);
        return;
      }
      setLoading(true);
      dispatch(clearCandidateSessionData());
      dispatch(resetChat());

      await dispatch(fetchJobById(jobId));
      await dispatch(fetchCandidateProfile(jobId, candidateId));
      dispatch(refreshRecruiterConversation(candidateId));

      const payload = {
        job_id: jobId,
        job_candidate_id: candidateId,
      };

      const res = await dispatch(createShareLink(payload));
      if (res.success) {
        setShareData(res.data);
      }

      setLoading(false);
    };

    fetchData();
  }, [jobId, candidateId, dispatch]);

  useEffect(() => {
    const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const matched = TimeZone.find((tz) => tz.value === detected);
    if (matched) setTimezone(matched);
  }, []);

  const score = candidate?.match_score || 0;

  const changeType = async (typeIndex) => {
    setTestType(typeIndex);
    setTabLoading(true);

    try {
      if (typeIndex === 0) {
        // Pre Screening
        const PRE_SCREENING_STAGE_ID = "3dab71cf-c680-4983-a109-1cff0953999b";
        const preScreeningStages = candidate?.hiring_stages?.filter(
          (stage) => stage.hiring_stage_id === PRE_SCREENING_STAGE_ID,
        );
        const preScreeningStage =
          preScreeningStages?.reduce((latest, curr) =>
            new Date(curr.created_at) > new Date(latest.created_at)
              ? curr
              : latest,
          ) || null;
        const status = preScreeningStage?.status?.name?.trim().toLowerCase();
        if (status === "completed") {
          // always clear previous report before fetching new one
          dispatch({ type: "CLEAR_PREQUALIFYING_REPORT" });
          await dispatch(getPreScreeningReport(candidateId));
        }
      }

      if (typeIndex === 1 && candidate?.voice_call_id && !voiceSession) {
        await dispatch(fetchVoiceCallSession(candidate.voice_call_id));
      }

      if (typeIndex === 2 && candidate?.invite_id && !assessmentInviteDetails) {
        await dispatch(fetchAssessmentInviteDetails(candidate.invite_id));
      }

      if (typeIndex === 3 && candidate?.video_call_id && !videoSession) {
        await dispatch(fetchVideoCallDetails(candidate.video_call_id));
      }
    } catch (error) {
      console.error("Error in changeType:", error);
    } finally {
      setTabLoading(false);
    }
  };

  useEffect(() => {
    if (!candidate?.id) return;
    setTestType((prev) => {
      if (prev === 0 && fromTab) {
        const tabIndex = tabTypeMap[fromTab] ?? 0;
        changeType(tabIndex);
      }
      return prev;
    });
  }, [fromTab, candidate]);

  useEffect(() => {
    if (!window.bootstrap) return;

    // Destroy old tooltips
    tooltipRef.current.forEach((t) => t.dispose?.());
    tooltipRef.current = [];

    // Recreate tooltips
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]'),
    );

    tooltipTriggerList.forEach((el) => {
      const tooltip = new window.bootstrap.Tooltip(el, {
        trigger: "hover",
      });
      tooltipRef.current.push(tooltip);
    });

    // 🔥 RETURN CLEANUP — runs on unmount or before re-running this effect
    return () => {
      tooltipRef.current.forEach((t) => t.dispose?.());
      tooltipRef.current = [];
    };
  }, [
    cheatingFrames,
    showAllCheatingImages,
    latestJob?.enable_candidate_report_share,
    shareData?.view_count,
  ]);

  useEffect(() => {
    if (!jobId || !scheduleDate || !timezone) return;

    const formattedDate = moment(scheduleDate).format("YYYY-MM-DD");
    dispatch(fetchAvailableSlots(jobId, formattedDate, timezone.value));
  }, [scheduleDate, timezone]);

  const handleVoiceCall = async () => {
    setLoadingCall(true);
    const result = await dispatch(fetchVoiceAssistants());
    setLoadingCall(false);

    if (result.success) {
      setAssistants(result.data);
      setShowAssistantModal(true);
    }
    setLoadingCall(false);
  };

  const snackClosed = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackOpen(false);
  };

  const showSnack = (message, severity = "error") => {
    setSnackMessage(message);
    setSnackSeverity(severity);
    setSnackOpen(true);
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };
    return date.toLocaleString("en-GB", options).replace(",", "");
  };
  const formatDateOnly = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
    };
    return date.toLocaleDateString("en-GB", options);
  };
  const formatExpiry = (dateString) => {
    return moment(dateString).format("MMMM-DD-YYYY");
  };

  const sendVideoInvite = async () => {
    if (modalType === "video" && !videoAgentType) {
      return showSnack("Please select an agent type.");
    }
    if (modalType === "video" && videoAgentType === "ai_interview" && !scheduleDate) {
      return showSnack("Please select a due date.");
    }
    if (modalType !== "video" && (!scheduleDate || (modalType === "voice" && (!timezone || !slotId)))) {
      return showSnack("Please select all fields.");
    }

    const isHybrid = modalType === "video" && videoAgentType === "hybrid";

    const basePayload = {
      job_hiring_stage_id: filterStageId,
      job_candidate_id: candidate?.id,
      ...(!isHybrid && {
        schedule_date: new Date(scheduleDate).toISOString(),
        expire_at: new Date(scheduleDate).toISOString(),
        valid_till: new Date(scheduleDate).toISOString(),
      }),
      trigger_now: false,
      ...(modalType === "video" && { video_interview_type: videoAgentType }),
    };

    if (modalType === "voice") {
      basePayload.current_timezone =
        Intl.DateTimeFormat().resolvedOptions().timeZone;
      basePayload.schedule_timezone = timezone.value;
      basePayload.slot_id = slotId;
    }
    const payload = [basePayload];

    setStageLoading(true);
    const status = await dispatch(assignedStage(jobId, payload));
    setStageLoading(false);

    if (status === 200) {
      await dispatch(fetchCandidateProfile(jobId, candidateId));
      setModalType("");
      setShowVideoModal(false);
      setSlotId(null);
      setVideoAgentType("");
    } else {
    }
  };

  const handleVoiceRefresh = async () => {
    if (!currentStage?.created_at) return;

    const createdAt = new Date(currentStage.created_at);
    const now = new Date();
    const diffMinutes = Math.floor((now - createdAt) / 60000);

    if (diffMinutes < 15) {
      const waitTime = 15 - diffMinutes;
      const message = `Voice call triggered at ${formatDateTime(
        currentStage.created_at,
      )}. Please wait ${waitTime} more minute${
        waitTime > 1 ? "s" : ""
      } before refreshing.`;
      setSnackMessage(message);
      setSnackSeverity("info");
      setSnackOpen(true);
    } else {
      try {
        setRefreshing(true);
        setTabLoading(true);
        await dispatch(getVoiceSessionStatus(candidate.voice_call_id));
        await dispatch(fetchCandidateProfile(jobId, candidateId));
        setSnackSeverity("success");
        setSnackMessage("Candidate profile updated successfully.");
        setSnackOpen(true);
      } catch (error) {
        setSnackSeverity("error");
        setSnackMessage("Failed to refresh profile. Please try again.");
        setSnackOpen(true);
      } finally {
        setRefreshing(false);
        setTabLoading(false);
      }
    }
  };

  const handleScheduleVoice = () => {
    setShowVideoModal(true);
    setModalType("voice");

    const formattedDate = moment(scheduleDate).format("YYYY-MM-DD");

    dispatch(fetchAvailableSlots(jobId, formattedDate, detectedTz));
  };

  const stagePermissionMap = React.useMemo(() => {
    if (!candidate?.hiring_stages?.length) return {};

    const grouped = {};

    candidate.hiring_stages.forEach((stage) => {
      const masterStageId = stage.hiring_stage_id;
      if (!masterStageId) return;

      if (!grouped[masterStageId]) {
        grouped[masterStageId] = [];
      }
      grouped[masterStageId].push(stage);
    });

    const result = {};

    Object.entries(grouped).forEach(([masterStageId, records]) => {
      const latest = records.reduce((a, b) =>
        new Date(b.created_at) > new Date(a.created_at) ? b : a,
      );

      const latestStatus = normalizeStatus(latest?.status?.name);

      const canAssign =
        !latestStatus || ALLOWED_REASSIGN_STATUSES.includes(latestStatus);

      result[masterStageId] = {
        latestStatus,
        canAssign,
        message: canAssign
          ? null
          : `This stage was already been ${latest.status.name}, you cannot assign again`,
      };
    });

    return result;
  }, [candidate]);

  if (loading || !candidate) {
    return (
      <div className="candidate-profile">
        <div className="loading-overlay">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">
              Loading candidate profile...
            </span>
          </div>
        </div>
      </div>
    );
  }

  const videoCallJobStage = latestJob?.hiring_stages?.find(
    (s) => s.hiring_stage_id === StageIds["Video Call"],
  );
  const isVideoSettingsMissing =
    modalType === "video" &&
    videoAgentType === "hybrid" &&
    videoCallJobStage?.data?.video_interview_settings?.enable_ai_bot !== true;

  const filterStageId =
    latestJob?.hiring_stages?.length &&
    latestJob?.hiring_stages?.filter(
      (el) =>
        el.hiring_stage_id ===
        StageIds[
          testType === 0
            ? "Pre Screening"
            : testType === 1
              ? "Voice Call"
              : testType === 2
                ? "Assessment"
                : testType === 3
                  ? "Video Call"
                  : null
        ],
    )[0]?.id;

  const getCurrentStageObject = () => {
    const currentStageId =
      testType === 0
        ? StageIds["Pre Screening"]
        : testType === 1
          ? StageIds["Voice Call"]
          : testType === 2
            ? StageIds["Assessment"]
            : testType === 3
              ? StageIds["Video Call"]
              : null;

    if (!currentStageId || !candidate?.hiring_stages?.length) return null;

    const stages = candidate?.hiring_stages?.filter(
      (stage) => stage.hiring_stage_id === currentStageId,
    );

    if (!stages || stages.length === 0) return null;

    return stages.reduce((latest, curr) => {
      const currTime = new Date(curr.updated_at || curr.created_at).getTime();

      const latestTime = new Date(
        latest.updated_at || latest.created_at,
      ).getTime();

      if (currTime !== latestTime) {
        return currTime > latestTime ? curr : latest;
      }

      return curr.id > latest.id ? curr : latest;
    });
  };

  const currentStage = getCurrentStageObject();
  const currentStatus = currentStage?.status?.name?.toUpperCase() || null;

  const hasPreScreeningStage = latestJob?.hiring_stages?.some(
    (stage) => stage.hiring_stage_id === "3dab71cf-c680-4983-a109-1cff0953999b",
  );

  const handleScoreClick = (type) => {
    if (!voiceSession?.result?.analysis?.structured_analysis) return;

    const structured = voiceSession.result.analysis.structured_analysis;
    const weights = structured.weights_used || {};

    let data = [];
    let title = "";
    let score = 0;
    let max = 0;

    if (type === "technical") {
      title = "Technical Weighted Score";
      data = structured.technical_evaluation || [];
      score = structured.technical_weighted_score || 0;
      max = weights.technical || 60;
    } else if (type === "cultural") {
      title = "Cultural Fit Weighted Score";
      data = structured.cultural_fit_evaluation || [];
      score = structured.cultural_fit_weighted_score || 0;
      max = weights.cultural_fit || 15;
    } else if (type === "final") {
      title = "Final Weighted Score";
      data = [
        ...(structured.technical_evaluation || []),
        ...(structured.cultural_fit_evaluation || []),
      ];
      score = structured.final_weighted_score || 0;
      max =
        (weights.technical || 0) +
          (weights.cultural_fit || 0) +
          (weights.communication || 0) || 100;
    }

    setPopupTitle(`${title} (${score}/${max})`);
    setPopupData(data);
    setShowScorePopup(true);
  };

  const getStageInfo = (stageName) => {
    if (!candidate?.hiring_stages) return { status: "UNASSIGNED", score: null };

    const stageMap = {
      "Pre-Screening": "3dab71cf-c680-4983-a109-1cff0953999b",
      "Voice Interview": StageIds["Voice Call"],
      Assessments: StageIds["Assessment"],
      "Video Interview": StageIds["Video Call"],
    };

    const stageId = stageMap[stageName];
    const stages = candidate.hiring_stages.filter(
      (s) => s.hiring_stage_id === stageId,
    );

    if (stages.length === 0) return { status: "UNASSIGNED", score: null };

    const latestStage = stages.reduce((latest, curr) => {
      const latestTime = new Date(latest.created_at).getTime();
      const currTime = new Date(curr.created_at).getTime();
      return currTime > latestTime ? curr : latest;
    });

    const status = latestStage?.status?.name?.toUpperCase() || "UNASSIGNED";
    const score = status === "COMPLETED" ? latestStage?.score : null;

    return { status, score };
  };

  const selectAssignedStage = async (stageId, videoDate, timezone, videoInterviewType) => {
    const isHybrid = videoInterviewType === "hybrid";
    const payload = [
      {
        job_hiring_stage_id: stageId,
        job_candidate_id: candidate?.id,
        ...(!isHybrid && {
          schedule_date: new Date().toISOString(),
        expire_at: new Date(videoDate).toISOString(),
        valid_till: new Date(videoDate).toISOString(),
        current_timezone: timezone,
        schedule_timezone: timezone,
        }),
        ...(videoInterviewType && { video_interview_type: videoInterviewType }),
      },
    ];

    setAssignProgress({ current: 0, total: 1 });
    const status = await dispatch(assignedStage(jobId, payload));

    if (status === 200) {
      await dispatch(fetchCandidateProfile(jobId, candidateId));
      setAssignProgress({ current: 1, total: 1 });
      setIsOpen(false);
    } else {
      showSnack("Failed to assign stage");
    }

    // reset progress
    setAssignProgress({ current: 0, total: 0 });
  };

  const handleStatusChange = async (statusName) => {
    if (!candidate?.id) return;

    const statusId = HIRING_STATUS_IDS[statusName];
    if (!statusId) {
      return showSnack("Invalid hiring status");
    }

    try {
      setStatusLoading(true);

      const res = await dispatch(
        updateCandidateDetails(jobId, candidate.id, {
          hiring_status_id: statusId,
        }),
      );

      if (res?.success) {
        // Re-fetch updated profile
        const profileRes = await dispatch(
          fetchCandidateProfile(jobId, candidate.id),
        );

        // (Optional but consistent with candidates.js)
        await dispatch(fetchJobById(jobId));

        if (profileRes?.success) {
          showSnack(
            `Candidate hiring status updated to ${statusName} successfully`,
            "success",
          );
        } else {
          showSnack("Status updated but failed to refresh profile");
        }
      } else {
        showSnack(res?.message || `Failed to update status to ${statusName}`);
      }
    } catch (err) {
      showSnack(err?.message || `Unexpected error updating ${statusName}`);
    } finally {
      setStatusLoading(false);
    }
  };

  const handleOpenSharePopup = async () => {
    setShowSharePopup(true);
    setShareLoading(true);

    if (shareData) {
      setShareLoading(false);
    } else {
      setShareLoading(false);
      setShowSharePopup(false);
      showSnack("Failed to generate share link", "error");
    }
  };

  const changeEmail = (values) => {
    setShareEmails(values || []);
  };

  const handleSendInvite = async () => {
    if (!shareEmails.length) {
      return showSnack("Please enter at least one email", "error");
    }

    setShareLoading(true);

    const emailArray = shareEmails.map((item) => item.value);

    const payload = {
      share_token: shareData.share_token,
      recipient_emails: emailArray,
    };

    const res = await dispatch(sendShareEmail(payload));

    setShareLoading(false);

    if (res.success) {
      showSnack("Invite sent successfully!", "success");
      setShareEmails([]); // reset CreatableSelect
      setShowSharePopup(false);
    } else {
      showSnack(res.message || "Failed to send invite", "error");
    }
  };

  const toggleOnboardingForm = (formId) =>
    setExpandedOnboardingForms((prev) => ({ ...prev, [formId]: !prev[formId] }));

  const handleFlowSearch = (inputValue) => {
    if (flowSearchDebounceRef.current) clearTimeout(flowSearchDebounceRef.current);
    flowSearchDebounceRef.current = setTimeout(() => {
      setOnboardingFlowsLoading(true);
      dispatch(fetchFlows(1, 50, inputValue ? `search=${encodeURIComponent(inputValue)}` : '')).then(res => {
        setOnboardingFlows(res?.data || []);
        setOnboardingFlowsLoading(false);
      });
    }, 400);
  };

  const handleViewOnboardingRun = async (runId) => {
    setOnboardingViewModal({ open: true, runId, data: null, loading: true });
    const res = await dispatch(getRecruiterRunView(runId));
    setOnboardingViewModal({ open: true, runId, data: res?.data || res || null, loading: false });
  };

  const handleOnboardingRequestChanges = (runId) => {
    setOnboardingCommentModal({ open: true, runId, value: '' });
  };

  const handleSubmitOnboardingRequestChanges = async () => {
    const { runId, value } = onboardingCommentModal;
    if (!value.trim()) { showSnack('Please enter a message for the candidate.'); return; }
    setOnboardingCommentModal((m) => ({ ...m, open: false }));
    setOnboardingViewModal((m) => ({ ...m, loading: true }));
    await dispatch(requestRunChanges(runId, { comment: value.trim(), send_email: true }));
    const res = await dispatch(getRecruiterRunView(runId));
    setOnboardingViewModal((m) => ({ ...m, data: res?.data || res || null, loading: false }));
    showSnack('Change request sent to the candidate.', 'success');
  };

  const handleCompleteOnboardingReview = async (runId) => {
    setOnboardingViewModal((m) => ({ ...m, loading: true }));
    await dispatch(completeRunReview(runId));
    await dispatch(fetchCandidateProfile(jobId, candidateId));
    setOnboardingViewModal({ open: false, runId: null, data: null, loading: false });
    showSnack('Onboarding marked as completed!', 'success');
  };

  return (
    <div className="candidate-profile">
      <Dialog
        className="schedule-loader"
        open={stageLoading}
        onClose={() => {}}
        PaperProps={{
          sx: {
            boxShadow: "none",
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Dialog>
      <div className="candidate-details">
        <div className="candidate-info">
          {candidate ? (
            <div key={candidate.id} className="candidate-detail-info">
              <div className="candidate-info-image">
                <div className="d-flex align-items-center justify-content-center">
                  {!isSharedReport && (
                    <img
                      src="/images/leftarrow-black-icon.svg"
                      alt=""
                      onClick={() => navigate(`/jobs/${jobId}/candidates`)}
                      className="cursor-pointer"
                      title="Back"
                    />
                  )}
                  &nbsp;&nbsp;
                  {!isMobile && (
                    <div className="user-avatar">
                      {candidate.name?.charAt(0).toUpperCase() || "U"}
                    </div>
                  )}
                  &nbsp;
                  <div>
                    <h4>{candidate?.name}</h4>
                    <div className="d-flex flex-wrap gap-2">
                      <p>{candidate?.job?.title}</p>
                      <p>
                        Hiring Status:{" "}
                        {candidate?.hiring_status?.name || "Not updated"}
                      </p>
                    </div>
                  </div>
                </div>
                {!isSharedReport && (
                  <div className="share-profile">
                    {/* {!isMobile && <p>Share report</p>} */}
                    <div className="d-flex gap-3">
                      <div className="message-button-wrapper">
                        <button
                          className="message-btn"
                          onClick={() => navigate(`/messenger?jcId=${candidateId}`)}
                          title="Open candidate chat"
                        >
                          <img src="/images/send.svg" alt="" width={16} height={16} style={{filter: 'brightness(0) invert(1)'}}/>
                          {!isMobile && "Message"}
                          {chatConversation?.unread_count > 0 && (
                            <span className="unread-badge">
                              {chatConversation?.unread_count > 99 ? '99+' : chatConversation?.unread_count}
                            </span>
                          )}
                        </button>
                      </div>
                      <button
                        className="share-btn"
                        style={{
                          background: latestJob?.enable_candidate_report_share
                            ? "#F75891"
                            : "#D3D3D3",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          if (!latestJob?.enable_candidate_report_share) {
                            navigate(`/jobs/${jobId}/settings`);
                            return;
                          }
                          handleOpenSharePopup();
                        }}
                        data-bs-toggle="tooltip"
                        title={
                          latestJob?.enable_candidate_report_share
                            ? null
                            : "You have disabled share option, click to enable it again"
                        }
                      >
                        <img
                          src="/images/share-icon.svg"
                          alt=""
                          width={16}
                          height={13}
                        />
                        {isMobile ? "" : "Share Report"}
                      </button>
                      <button
                        className="view-btn"
                        style={{
                          background: latestJob?.enable_candidate_report_share
                            ? "#EEF2F7"
                            : "#D3D3D3",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          if (!latestJob?.enable_candidate_report_share) {
                            navigate(`/jobs/${jobId}/settings`);
                          }
                        }}
                        data-bs-toggle="tooltip"
                        title={
                          latestJob?.enable_candidate_report_share
                            ? null
                            : "You have disabled share option, click to enable it again"
                        }
                      >
                        {isMobile && (
                          <img
                            src="/images/eye-black-icon.svg"
                            alt=""
                            width={12}
                            height={12}
                          />
                        )}{" "}
                        {shareData?.view_count || 0} {isMobile ? "" : "Views"}
                      </button>
                    </div>
                  </div>
                )}
              </div>
              {!isMobile && (
                <div className="d-flex flex-wrap">
                  <div>
                    <div className="candidate-info-details">
                      <div className="details-div">
                        <p>Email</p>
                        {hideSensitive ? (
                          <span className="blur-text">***********</span>
                        ) : (
                          candidate.email || "null"
                        )}
                      </div>
                      <div className="details-div">
                        <p>Phone number</p>
                        <h5>
                          {hideSensitive ? (
                            <span className="blur-text">***********</span>
                          ) : (
                            candidate.phone_number || "null"
                          )}
                        </h5>
                      </div>
                      <div className="details-div" style={{ width: "200px" }}>
                        <p>Location</p>
                        <h5>{candidate.location || "N/A"}</h5>
                      </div>
                    </div>
                    <div className="candidate-info-details">
                      <div className="details-div">
                        <p>Skills</p>
                        <div
                          className="d-flex flex-wrap"
                          style={{ gap: "5px" }}
                        >
                          {candidate.skills
                            ?.slice(0, 2)
                            .map((skills, index) => (
                              <h5 className="candidate-skills" key={index}>
                                {skills}
                              </h5>
                            ))}
                          {candidate.skills?.length > 2 && (
                            <div className="candidate-skills more-skills">
                              +{candidate.skills.length - 2} more
                              <div className="skills-popup">
                                {candidate.skills
                                  .slice(2)
                                  .map((s, idx, arr) => (
                                    <span className="popup-skill-tag" key={idx}>
                                      {s}
                                      {idx < arr.length - 1 && ", "}
                                    </span>
                                  ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="details-div">
                        <p>Qualifications</p>
                        <h5>{candidate.qualifications || "null"}</h5>
                      </div>
                      <div className="details-div" style={{ width: "200px" }}>
                        <p>Years of experience</p>
                        <h5>{candidate?.years_of_experience || "null"}</h5>
                      </div>
                    </div>
                  </div>
                  {score <= 0 ? null : (
                    <div className="candidate-score">
                      <div className="candidate-score-container">
                        <CircularProgressRing
                          percentage={score || 0}
                          label="Resume score"
                        />
                      </div>
                      <div className="d-flex">
                        <button
                          className="view-summary-btn"
                          onClick={() => setShowSummaryPopup(true)}
                        >
                          View Summary
                        </button>
                        <button
                          className="view-summary-btn"
                          style={{ padding: "0" }}
                          title="Download Resume"
                          onClick={() => {
                            if (isSharedReport) {
                              setShowAccessModal(true);
                              return;
                            }

                            if (candidate?.resume_url) {
                              const url = candidate.resume_url;
                              const filename = url.split("/").pop();
                              const newTab = window.open(url, "_blank");
                              if (newTab) {
                                const a = newTab.document.createElement("a");
                                a.href = url;
                                a.download = filename;
                                newTab.document.body.appendChild(a);
                                a.click();
                                newTab.document.body.removeChild(a);
                              }
                            }
                          }}
                        >
                          <img
                            src="/images/download-pink.svg"
                            alt=""
                            width={16}
                            height={16}
                          />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          ) : (
            <p>Loading candidate profile...</p>
          )}
        </div>
      </div>
      {isMobile ? (
        <div className="candidate-tabs">
          <div className="search-tests">
            <div className="types-tab d-flex align-items-center">
              <div
                className={tabType === 0 ? "type-btn active-type" : "type-btn"}
                onClick={() => setTabType(0)}
              >
                <div className="type-btn-status">
                  <h4>Stage results</h4>
                </div>
              </div>
              <div
                className={tabType === 1 ? "type-btn active-type" : "type-btn"}
                onClick={() => setTabType(1)}
              >
                <div className="type-btn-status">
                  <h4>Candidate info</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="candidate-tabs">
          {!isSharedReport && (
            <div className="assign-stage">
              <div>
                <button onClick={() => setIsOpen(true)}>
                  Assign stage <img src="/images/right-arrow.svg" alt="" />
                </button>
              </div>
              <div className="quick-actions">
                <p>Quick Actions</p>
                <div className="status-btn">
                  {statusLoading ? (
                    <div
                      className="spinner-border"
                      role="status"
                      style={{
                        width: "1rem",
                        height: "1rem",
                        color: "#F75891",
                      }}
                    >
                      <span className="visually-hidden">
                        Updating status...
                      </span>
                    </div>
                  ) : (
                    QUICK_ACTIONS.map((action) => {
                      const hiringStatusName =
                        candidate?.hiring_status?.name || "In Progress";
                      const isActive = hiringStatusName === action.name;
                      const activeStyle = isActive
                        ? buttonStyleMap[action.name]
                        : {};

                      return (
                        <button
                          key={action.name}
                          style={{
                            background: isActive
                              ? activeStyle?.background
                              : "#E4E9F0",
                            border: isActive
                              ? activeStyle?.border
                              : "1px solid transparent",
                            marginRight: "4px",
                          }}
                          onClick={() => handleStatusChange(action.name)}
                          disabled={isSharedReport}
                          title={action.name}
                        >
                          <img
                            src={action.icon}
                            alt={action.name}
                            width={action.width}
                            height={action.height}
                          />
                        </button>
                      );
                    })
                  )}
                </div>
                <div>
                  {candidate?.onboarding?.run_id ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                      <span style={{ fontSize: 12, color: '#525b66', fontWeight: 500, whiteSpace: 'nowrap' }}>
                        Onboarding:
                      </span>
                      <button
                        style={{ width: 'unset', background: 'transparent', border: '1px solid #e4e9f0', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12, fontWeight: 500, color: '#525b66', display: 'flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap' }}
                        onClick={() => handleViewOnboardingRun(candidate.onboarding.run_id)} title="View Candidate Progress"
                      >
                        View
                      </button>
                    </div>
                  ) : (
                    <button
                      title="Initiate Onboarding"
                      style={{ width: 'unset', background: 'transparent', border: '1px solid #e4e9f0', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12, fontWeight: 500, color: '#f75891', display: 'flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap' }}
                      onClick={() => {
                        setOnboardingForm({ flowId: '', joiningDate: '' });
                        setOnboardingAdditionalDocs([]);
                        setOnboardingModalOpen(true);
                        setOnboardingFlowsLoading(true);
                        dispatch(fetchFlows(1, 50)).then(res => {
                          setOnboardingFlows(res?.data || []);
                          setOnboardingFlowsLoading(false);
                        });
                      }}
                    >
                      <img src="/images/send.svg" alt="" width={18} height={18} /> Initiate onboarding
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="search-tests">
            <h3>Stage results</h3>
            <div className="types-tab d-flex align-items-center">
              {hasPreScreeningStage && (
                <div>
                  <div
                    className={
                      testType === 0 ? "type-btn active-type" : "type-btn"
                    }
                    onClick={() => changeType(0)}
                  >
                    <div className="type-btn-status">
                      <h4>Pre-Screening</h4>
                      {(() => {
                        const { status } = getStageInfo("Pre-Screening");
                        return (
                          <h5
                            style={{
                              color: STATUS_COLORS[status],
                            }}
                          >
                            {status}
                          </h5>
                        );
                      })()}
                    </div>
                    {(() => {
                      const { score } = getStageInfo("Pre-Screening");
                      if (score !== null) {
                        return (
                          <div className="type-btn-score">
                            <p>{score ? `${score.toFixed(2)}%` : "--"}</p>
                          </div>
                        );
                      }
                      return null;
                    })()}
                  </div>
                </div>
              )}
              <div>
                <div
                  className={
                    testType === 1 ? "type-btn active-type" : "type-btn"
                  }
                  onClick={() => changeType(1)}
                >
                  <div className="type-btn-status">
                    <h4>Telephonic Interview</h4>
                    {(() => {
                      const { status } = getStageInfo("Voice Interview");
                      return (
                        <h5
                          style={{
                            color: STATUS_COLORS[status],
                          }}
                        >
                          {status}
                        </h5>
                      );
                    })()}
                  </div>
                  {(() => {
                    const { score } = getStageInfo("Voice Interview");
                    if (score !== null) {
                      return (
                        <div className="type-btn-score">
                          <p>{score ? `${score.toFixed(2)}%` : "--"}</p>
                        </div>
                      );
                    }
                    return null;
                  })()}
                </div>
              </div>
              <div>
                <div
                  className={
                    testType === 2 ? "type-btn active-type" : "type-btn"
                  }
                  onClick={() => changeType(2)}
                >
                  <div className="type-btn-status">
                    <h4>Assessments</h4>
                    {(() => {
                      const { status } = getStageInfo("Assessments");
                      return (
                        <h5
                          style={{
                            color: STATUS_COLORS[status],
                          }}
                        >
                          {status}
                        </h5>
                      );
                    })()}
                  </div>
                  {(() => {
                    const { score } = getStageInfo("Assessments");
                    if (score !== null) {
                      return (
                        <div className="type-btn-score">
                          <p>{score ? `${score.toFixed(2)}%` : "--"}</p>
                        </div>
                      );
                    }
                    return null;
                  })()}
                </div>
              </div>
              <div>
                <div
                  className={
                    testType === 3 ? "type-btn active-type" : "type-btn"
                  }
                  onClick={() => changeType(3)}
                >
                  <div className="type-btn-status">
                    <h4>Video Interview</h4>
                    {(() => {
                      const { status } = getStageInfo("Video Interview");
                      return (
                        <h5
                          style={{
                            color: STATUS_COLORS[status],
                          }}
                        >
                          {status}
                        </h5>
                      );
                    })()}
                  </div>
                  {(() => {
                    const { score } = getStageInfo("Video Interview");
                    if (score !== null) {
                      return (
                        <div className="type-btn-score">
                          <p>{score ? `${score.toFixed(2)}%` : "--"}</p>
                        </div>
                      );
                    }
                    return null;
                  })()}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {!isMobile && (
        <div
          style={{
            backgroundColor: "#FFFFFF",
            border: "1px solid #E4E9F0",
            borderRadius: "4px",
            borderTopLeftRadius: "0",
            borderTopRightRadius: "0",
          }}
        >
          {testType === 0 && (
            <PreScreeningStage
              candidate={candidate}
              preQualifyingReport={preQualifyingReport}
              tabLoading={tabLoading}
              formatExpiry={formatExpiry}
              isSharedReport={isSharedReport}
              setPreselectStage={setPreselectStage}
              setIsOpen={setIsOpen}
            />
          )}
          {testType === 1 && (
            <VoiceInterviewStage
              candidate={candidate}
              voiceSession={voiceSession}
              currentStage={currentStage}
              currentStatus={currentStatus}
              tabLoading={tabLoading}
              isSharedReport={isSharedReport}
              handleVoiceCall={handleVoiceCall}
              handleVoiceRefresh={handleVoiceRefresh}
              formatDateTime={formatDateTime}
              onScheduleVoice={handleScheduleVoice}
              loadingCall={loadingCall}
              refreshing={refreshing}
              audioLoading={audioLoading}
              setAudioLoading={setAudioLoading}
              expandSummary={expandSummary}
              setExpandSummary={setExpandSummary}
              expandRecommendation={expandRecommendation}
              setExpandRecommendation={setExpandRecommendation}
              handleScoreClick={handleScoreClick}
              setShowPhoneCheckModal={setShowPhoneCheckModal}
              initiatingVideoCall={initiatingVideoCall}
            />
          )}
          <>
            {testType === 2 && (
              <AssessmentStage
                candidate={candidate}
                currentStage={currentStage}
                currentStatus={currentStatus}
                assessmentInviteDetails={assessmentInviteDetails}
                latestJob={latestJob}
                tabLoading={tabLoading}
                isSharedReport={isSharedReport}
                formatDateOnly={formatDateOnly}
                formatDateTime={formatDateTime}
                navigate={navigate}
                setShowVideoModal={setShowVideoModal}
                setModalType={setModalType}
                assessmentStatus={assessmentStatus}
                initiatingVideoCall={initiatingVideoCall}
                inlineReportId={inlineReportId}
                setInlineReportId={setInlineReportId}
                showInlineReport={showInlineReport}
                setShowInlineReport={setShowInlineReport}
                useSharedToken={props.useSharedToken}
              />
            )}
          </>
          {testType === 3 && (
            <VideoInterviewStage
              videoSession={videoSession}
              currentStage={currentStage}
              currentStatus={currentStatus}
              tabLoading={tabLoading}
              isSharedReport={isSharedReport}
              isPlaying={isPlaying}
              setIsPlaying={setIsPlaying}
              formatDateOnly={formatDateOnly}
              setShowVideoModal={setShowVideoModal}
              setModalType={setModalType}
              initiatingVideoCall={initiatingVideoCall}
              proctoring={proctoring}
              cheatingFrames={cheatingFrames}
              showAllCheatingImages={showAllCheatingImages}
              setShowAllCheatingImages={setShowAllCheatingImages}
              selectedProctorIndex={selectedProctorIndex}
              setSelectedProctorIndex={setSelectedProctorIndex}
              setOpenProctorLightbox={setOpenProctorLightbox}
              setSelectedProctorImage={setSelectedProctorImage}
            />
          )}
        </div>
      )}
      {isMobile && (
        <>
          {tabType === 0 && (
            <div className="mobile-tabs">
              {MOBILE_STAGES.map((stage) => {
                const { status, score } = getStageInfo(stage.key);
                const isCompleted = status === "COMPLETED";
                const isOpen = openMobileStage === stage.key;

                return (
                  <div key={stage.key} className="mobile-tabs-items-wrapper">
                    
                    <div
                      className="mobile-tabs-items"
                      onClick={() => {
                        if (isOpen) {
                          setOpenMobileStage(null);
                          return;
                        }

                        const nextTestType = MOBILE_STAGE_TO_TESTTYPE[stage.key];

                        setOpenMobileStage(stage.key);
                        setTestType(nextTestType);
                        changeType(nextTestType);
                      }}
                    >
                      <div className="tab-details" style={{ width: "150px" }}>
                        <h4>{stage.label}</h4>
                        <p>
                          <span
                            className="status-dot"
                            style={{
                              background: STATUS_COLORS[status] || "#8A9199",
                            }}
                          />
                          {status}
                        </p>
                      </div>

                      <div className="tab-progresbar">
                        {isCompleted && score !== null && (
                          <CircularProgressRing
                            percentage={Number(score.toFixed(2))}
                            size={56}
                          />
                        )}
                      </div>

                      <div className="tab-right-arrow">
                        <img
                          src="/images/leftarrow-black-icon.svg"
                          alt="arrow"
                          width={24}
                          height={24}
                          style={{
                            transform: isOpen
                              ? "rotate(90deg)"
                              : "rotate(180deg)",
                            transition: "transform 0.25s ease",
                          }}
                        />
                      </div>
                    </div>

                    {/* ACCORDION BODY */}
                    {isOpen && (
                      <div className="mobile-stage-content" style={{borderBottom : '1px solid #E4E9F0'}}>
                        {stage.key === "Pre-Screening" && (
                          <PreScreeningStage
                            candidate={candidate}
                            preQualifyingReport={preQualifyingReport}
                            tabLoading={tabLoading}
                            formatExpiry={formatExpiry}
                            isSharedReport={isSharedReport}
                            setPreselectStage={setPreselectStage}
                            setIsOpen={setIsOpen}
                          />
                        )}

                        {stage.key === "Voice Interview" && (
                          <VoiceInterviewStage
                            candidate={candidate}
                            voiceSession={voiceSession}
                            currentStage={currentStage}
                            currentStatus={currentStatus}
                            tabLoading={tabLoading}
                            isSharedReport={isSharedReport}
                            handleVoiceCall={handleVoiceCall}
                            handleVoiceRefresh={handleVoiceRefresh}
                            formatDateTime={formatDateTime}
                            onScheduleVoice={handleScheduleVoice}
                            loadingCall={loadingCall}
                            refreshing={refreshing}
                            audioLoading={audioLoading}
                            setAudioLoading={setAudioLoading}
                            expandSummary={expandSummary}
                            setExpandSummary={setExpandSummary}
                            expandRecommendation={expandRecommendation}
                            setExpandRecommendation={setExpandRecommendation}
                            handleScoreClick={handleScoreClick}
                            setShowPhoneCheckModal={setShowPhoneCheckModal}
                            initiatingVideoCall={initiatingVideoCall}
                          />
                        )}

                        {stage.key === "Assessments" && (
                          <AssessmentStage
                            candidate={candidate}
                            currentStage={currentStage}
                            currentStatus={currentStatus}
                            assessmentInviteDetails={assessmentInviteDetails}
                            latestJob={latestJob}
                            tabLoading={tabLoading}
                            isSharedReport={isSharedReport}
                            formatDateOnly={formatDateOnly}
                            formatDateTime={formatDateTime}
                            navigate={navigate}
                            setShowVideoModal={setShowVideoModal}
                            setModalType={setModalType}
                            assessmentStatus={assessmentStatus}
                            initiatingVideoCall={initiatingVideoCall}
                            inlineReportId={inlineReportId}
                            setInlineReportId={setInlineReportId}
                            showInlineReport={showInlineReport}
                            setShowInlineReport={setShowInlineReport}
                            useSharedToken={props.useSharedToken}
                          />
                        )}

                        {stage.key === "Video Interview" && (
                          <VideoInterviewStage
                            videoSession={videoSession}
                            currentStage={currentStage}
                            currentStatus={currentStatus}
                            tabLoading={tabLoading}
                            isSharedReport={isSharedReport}
                            isPlaying={isPlaying}
                            setIsPlaying={setIsPlaying}
                            formatDateOnly={formatDateOnly}
                            setShowVideoModal={setShowVideoModal}
                            setModalType={setModalType}
                            initiatingVideoCall={initiatingVideoCall}
                            proctoring={proctoring}
                            cheatingFrames={cheatingFrames}
                            showAllCheatingImages={showAllCheatingImages}
                            setShowAllCheatingImages={setShowAllCheatingImages}
                            selectedProctorIndex={selectedProctorIndex}
                            setSelectedProctorIndex={setSelectedProctorIndex}
                            setOpenProctorLightbox={setOpenProctorLightbox}
                            setSelectedProctorImage={setSelectedProctorImage}
                          />
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {tabType === 1 && (
            <div key={candidate.id} className="candidate-detail-info" style={{padding:'25px'}}>
              {score <= 0 ? null : (
                <div className="candidate-score">
                  <div className="candidate-score-container">
                    <CircularProgressRing
                      percentage={score || 0}
                      label="Resume score"
                    />
                  </div>
                  <div className="d-flex flex-column">
                    <button
                      className="view-summary-btn"
                      style={{ padding: "0" }}
                      onClick={() => {
                        if (isSharedReport) {
                          setShowAccessModal(true);
                          return;
                        }

                        if (candidate?.resume_url) {
                          const url = candidate.resume_url;
                          const filename = url.split("/").pop();
                          const newTab = window.open(url, "_blank");
                          if (newTab) {
                            const a = newTab.document.createElement("a");
                            a.href = url;
                            a.download = filename;
                            newTab.document.body.appendChild(a);
                            a.click();
                            newTab.document.body.removeChild(a);
                          }
                        }
                      }}
                    >
                      <img
                        src="/images/download-pink.svg"
                        alt=""
                        width={24}
                        height={24}
                        title="Download Resume"
                      />
                    </button>
                    <button
                      className="view-summary-btn"
                      onClick={() => setShowSummaryPopup(true)}
                    >
                      View Summary
                    </button>
                  </div>
                </div>
              )}
              <div className="d-flex flex-wrap">
                <div>
                  <div className="candidate-info-details">
                    <div className="details-div">
                      <p>Email</p>
                      {hideSensitive ? (
                        <span className="blur-text">***********</span>
                      ) : (
                        candidate.email || "null"
                      )}
                    </div>
                    <div className="details-div">
                      <p>Phone number</p>
                      <h5>
                        {hideSensitive ? (
                          <span className="blur-text">***********</span>
                        ) : (
                          candidate.phone_number || "null"
                        )}
                      </h5>
                    </div>
                    <div className="details-div" style={{ width: "200px" }}>
                      <p>Location</p>
                      <h5>{candidate.location || "N/A"}</h5>
                    </div>
                  </div>
                  <div className="candidate-info-details">
                    <div className="details-div">
                      <p>Skills</p>
                      <div className="d-flex flex-wrap" style={{ gap: "5px" }}>
                        {candidate.skills?.slice(0, 2).map((skills, index) => (
                          <h5 className="candidate-skills" key={index}>
                            {skills}
                          </h5>
                        ))}
                        {candidate.skills?.length > 2 && (
                          <div className="candidate-skills more-skills">
                            +{candidate.skills.length - 2} more
                            <div className="skills-popup">
                              {candidate.skills.slice(2).map((s, idx, arr) => (
                                <span className="popup-skill-tag" key={idx}>
                                  {s}
                                  {idx < arr.length - 1 && ", "}
                                </span>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="details-div">
                      <p>Qualifications</p>
                      <h5>{candidate.qualifications || "null"}</h5>
                    </div>
                    <div className="details-div" style={{ width: "200px" }}>
                      <p>Years of experience</p>
                      <h5>{candidate?.years_of_experience || "null"}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackOpen}
        autoHideDuration={3000}
        onClose={snackClosed}
      >
        <Alert
          onClose={snackClosed}
          severity={snackSeverity}
          sx={{ width: "100%" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>
      {showSummaryPopup && (
        <div className="upload-modal">
          <div
            className="modal-content"
            style={{ width: isMobile ? " " : "600px" , height: "auto" }}
          >
            <div className="modal-head">
              <h3>Resume Summary</h3>
              <img
                src="/images/close-icon.svg"
                alt="Close"
                style={{ cursor: "pointer" }}
                onClick={() => setShowSummaryPopup(false)}
              />
            </div>
            <div
              className="modal-input"
              style={{
                height: "220px",
                width: "auto",
                overflow: "auto",
                justifyContent: "unset",
              }}
            >
              <p>{candidate.assessment_summary || "No summary available."}</p>
            </div>
            <div className="d-flex justify-content-center">
              <button
                className="upload-btn"
                onClick={() => setShowSummaryPopup(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {showAssistantModal && (
        <div className="upload-modal">
          <div
            className="modal-content"
            style={{ width: isMobile ? " " : "600px" , height: "auto" }}
          >
            <div className="modal-head">
              <h3>Make a voice call with this assistant</h3>
              <img
                src="/images/close-icon.svg"
                alt="Close"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (currentAudio) currentAudio.pause();
                  setShowAssistantModal(false);
                }}
              />
            </div>
            <div className="modal-body" style={{maxHeight:'350px', overflowY:'auto', scrollbarWidth:'none'}}>
              {assistants.map((assistant, idx) => (
                <div
                  key={idx}
                  className={`assistant-option ${
                    selectedAssistantId === assistant.id
                      ? "selected"
                      : ""
                  }`}
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    padding: "12px",
                    margin: "8px 0",
                    cursor: "pointer",
                  }}
                  onClick={() => {setSelectedAssistantId(assistant.id);}}
                >
                  <div>
                    {assistant.voice_clip_url && (
                      <label style={{ width: "100%", cursor: "pointer" }}>
                        <input
                          type="radio"
                          name="assistant"
                          value={assistant.id}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (currentAudio) currentAudio.pause();
                            const audio = new Audio(assistant.voice_clip_url);
                            setCurrentAudio(audio);
                            // audio.play();
                          }}
                        />
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        {assistant.voice_name}
                      </label>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="d-flex justify-content-center">
              {!isSharedReport && (
                <button
                  className="upload-btn"
                  disabled={!selectedAssistantId}
                  style={{ width: "320px" }}
                  onClick={async () => {
                    if (currentAudio) currentAudio.pause();
                    setShowAssistantModal(false);
                    const now = new Date();
                    const detectedTz =
                      Intl.DateTimeFormat().resolvedOptions().timeZone;

                    const payload = [
                      {
                        job_hiring_stage_id: filterStageId,
                        job_candidate_id: candidate?.id,
                        schedule_date: now.toISOString(),
                        expire_at: now.toISOString(),
                        valid_till: now.toISOString(),
                        assistant_id: selectedAssistant.id,
                        trigger_now: true,
                        current_timezone: detectedTz,
                        schedule_timezone: detectedTz,
                      },
                    ];

                    setLoadingCall(true);
                    await dispatch(assignedStage(jobId, payload));
                    await dispatch(fetchCandidateProfile(jobId, candidateId));
                    setLoadingCall(false);
                  }}
                >
                  Make voice call with this assistant
                </button>
              )}
            </div>
          </div>
        </div>
      )}
      {showPhoneCheckModal && (
        <div className="upload-modal">
          <div
            className="modal-content"
            style={{ width: isMobile ? " " : "500px" , height: "auto" }}
          >
            <div className="modal-head">
              <h3>Phone Number Check</h3>
              <img
                src="/images/close-icon.svg"
                alt="Close"
                style={{ cursor: "pointer" }}
                onClick={() => setShowPhoneCheckModal(false)}
              />
            </div>
            <div className="modal-input" style={{ padding: "20px" }}>
              <p>Country code is missing in the mobile number.</p>
            </div>
            <div className="d-flex justify-content-center">
              <button
                className="upload-btn"
                onClick={() => setShowPhoneCheckModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      {showVideoModal && (
        <div className="upload-modal">
          <div className="modal-content">
            <div className="modal-head">
              <div></div>
              <h3>
                {modalType === "voice" && "Schedule a voice interview"}
                {modalType === "assessment" && "Send an assessment invite"}
                {modalType === "video" && "Schedule a video interview"}
              </h3>
              <img
                src="/images/close-icon.svg"
                alt="Close"
                onClick={() => {
                  setShowVideoModal(false);
                  setModalType("");
                  setVideoAgentType("");
                }}
                style={{ cursor: "pointer" }}
              />
            </div>
            <div
              className="modal-input d-flex flex-column align-items-start"
              style={{ gap: "15px", padding: "15px" }}
            >
              {modalType === "voice" && (
                <>
                  <div className="modal-input-label">
                    <label>Time Zone</label>
                    <Select
                      options={TimeZone}
                      value={timezone}
                      onChange={setTimezone}
                      placeholder="Select Timezone"
                    />
                  </div>
                </>
              )}
              {modalType === "video" && (
                <div className="modal-input-label">
                  <label>Agent Type</label>
                  <select
                    className="form-control"
                    value={videoAgentType}
                    onChange={(e) => setVideoAgentType(e.target.value)}
                  >
                    <option hidden value="">Select Agent Type</option>
                    <option value="hybrid">Ai Assisted Interview</option>
                    <option value="ai_interview">AI lead Interview</option>
                  </select>
                  {isVideoSettingsMissing && (
                    <div style={{ marginTop: "8px", color: "#6b7280", fontSize: "14px", fontWeight: 500 }}>
                      You haven't added the video interview settings, please add.
                    </div>
                  )}
                </div>
              )}
              {(modalType !== "video" || videoAgentType === "ai_interview") && (
                <div className="modal-input-label">
                  <label>Due Date</label>
                  <DatePicker
                    selected={scheduleDate}
                    onChange={(date) => setScheduleDate(date)}
                    minDate={new Date()}
                    maxDate={moment().add(15, "days").toDate()}
                    dateFormat="dd-MM-yyyy"
                    className="form-control"
                  />
                </div>
              )}
              {modalType === "voice" && (
                <>
                  <div className="modal-input-label">
                    <label>Time Slot</label>
                    <Select
                      options={availableSlots?.map((slot) => ({
                        label: slot.display,
                        value: slot.id,
                      }))}
                      value={
                        availableSlots
                          ?.map((slot) => ({
                            label: slot.display,
                            value: slot.id,
                          }))
                          .find((opt) => opt.value === slotId) || null
                      }
                      onChange={(selectedOption) =>
                        setSlotId(selectedOption.value)
                      }
                      placeholder="Select a time slot"
                      menuPlacement="bottom"
                      maxMenuHeight={200}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="d-flex justify-content-center">
              {!isSharedReport && (
                isVideoSettingsMissing ? (
                  <button
                    className="upload-btn"
                    onClick={() => navigate(`/jobs/${jobId}/settings`)}
                  >
                    Video Settings
                  </button>
                ) : (
                  <button
                    className="upload-btn"
                    disabled={
                      stageLoading ||
                      (modalType === "video" && !videoAgentType) ||
                      (modalType === "video" && videoAgentType === "ai_interview" && !scheduleDate)
                    }
                    onClick={sendVideoInvite}
                  >
                    Submit
                  </button>
                )
              )}
            </div>
          </div>
        </div>
      )}
      {showScorePopup && (
        <div className="upload-modal">
          <div
            className="modal-content"
            style={{ width: isMobile ? " " : "600px" , height: "auto" }}
          >
            <div className="modal-head">
              <h3>{popupTitle}</h3>
              <img
                src="/images/close-icon.svg"
                alt="close"
                className="cursor-pointer"
                onClick={() => setShowScorePopup(false)}
              />
            </div>

            <div className="modal-body modal-body-text">
              {popupData.length > 0 ? (
                popupData.map((item, index) => (
                  <div className="modal-body-question" key={index}>
                    <div className="d-flex justify-content-between gap-2">
                      <h5 style={{ width: "65%" }}>
                        {index + 1}. <span>{item.question}</span>
                      </h5>
                      <p>Score: {item.score}/5</p>
                    </div>
                    <p>Answer summary: {item.answer_summary}</p>
                  </div>
                ))
              ) : (
                <p>No data available.</p>
              )}
            </div>
            <div className="d-flex justify-content-center">
              <button
                className="upload-btn"
                onClick={() => setShowScorePopup(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {showSharePopup && (
        <div className="share-modal-overlay">
          <div className="share-modal">
            {/* Header */}
            <div className="share-modal-header">
              <h4>{candidate?.name || "Candidate"}</h4>
              <span
                onClick={() => {
                  setShareEmails("");
                  setShowSharePopup(false);
                }}
              >
                <img
                  src="/images/close-icon.svg"
                  alt="close"
                  className="cursor-pointer"
                />
              </span>
            </div>

            {/* Body */}
            {shareLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "120px" }}
              >
                <div className="spinner-border" role="status"></div>
              </div>
            ) : shareData ? (
              <>
                <h3>Share report</h3>

                <CreatableSelect
                  className="email-input"
                  isMulti
                  placeholder="Enter email ids"
                  value={shareEmails}
                  onChange={changeEmail}
                  styles={{
                    container: (base) => ({ ...base, width: "100%" }),
                  }}
                />

                <button
                  className="send-invite-btn"
                  onClick={handleSendInvite}
                  disabled={shareLoading}
                >
                  {shareLoading ? "Sending email..." : "Send email"}
                </button>

                <div className="share-footer">
                  <div style={{ width: "200px" }}>
                    <button
                      className="copy-link-btn"
                      onClick={() => {
                        navigator.clipboard.writeText(shareData.share_url);
                        showSnack("Link copied!", "success");
                      }}
                    >
                      <img
                        src="/images/copy-outline-wight-icon.svg"
                        alt=""
                        width={16}
                        height={16}
                      />
                      &nbsp; Copy Link
                    </button>

                    <div className="access-code">
                      Share access code <strong>{shareData.access_code}</strong>{" "}
                      to view link
                    </div>
                  </div>

                  <button
                    className="done-btn"
                    onClick={() => {
                      setShareEmails("");
                      setShowSharePopup(false);
                    }}
                  >
                    Close
                  </button>
                </div>
              </>
            ) : null}
          </div>
        </div>
      )}
      {showAccessModal && (
        <div className="upload-modal">
          <div className="modal-content" style={{ width: "360px" }}>
            <div className="modal-head">
              <div></div>
              <h3>Access Restricted</h3>
              <img
                src="/images/close-icon.svg"
                alt="Close"
                style={{ cursor: "pointer" }}
                onClick={() => setShowAccessModal(false)}
              />
            </div>

            <div style={{ padding: "20px", textAlign: "center" }}>
              <p>You don't have the required access to download this resume.</p>
            </div>

            <div className="d-flex justify-content-center">
              <button
                className="upload-btn"
                onClick={() => setShowAccessModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {onboardingModalOpen && (
        <div
          style={{
            position: 'fixed', inset: 0, background: 'rgba(26,26,46,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1100, padding: 16,
          }}
          onClick={() => setOnboardingModalOpen(false)}
        >
          <div
            style={{
              background: '#fff', borderRadius: 14, padding: 28,
              width: '100%', maxWidth: 460, boxShadow: '0 8px 40px rgba(26,26,46,0.18)',
              maxHeight: '85vh',
            }}
            onClick={e => e.stopPropagation()}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: '#1a1a2e' }}>Onboarding details</h3>
                <img
                  src="/images/close-icon.svg"
                  alt="Close"
                  style={{ cursor: 'pointer', width: 18, height: 18 }}
                  onClick={() => setOnboardingModalOpen(false)}
                />
            </div>
            <div style={{maxHeight: '65vh', overflowY: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none',}}>
              <div style={{ fontSize: 13, color: '#525b66', marginBottom: 20, padding: '10px 14px', background: '#f4f5f7', borderRadius: 8 }}>
                <strong style={{ color: '#1a1a2e' }}>{candidate?.name || 'Candidate'}</strong>
                <br />
                <span style={{ fontSize: 12, color: '#8a9199' }}>{candidate?.email}</span>
              </div>

              <div style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#525b66', marginBottom: 5 }}>
                  Select Flow <span style={{ color: '#f75891' }}>*</span>
                </label>
                <Select
                  options={onboardingFlows.map(flow => ({ value: flow.id, label: flow.name }))}
                  value={onboardingForm.flowId ? { value: onboardingForm.flowId, label: onboardingFlows.find(f => f.id === onboardingForm.flowId)?.name || '' } : null}
                  onChange={opt => setOnboardingForm(f => ({ ...f, flowId: opt ? opt.value : '' }))}
                  onInputChange={handleFlowSearch}
                  filterOption={null}
                  placeholder="Select an onboarding flow…"
                  isClearable
                  isLoading={onboardingFlowsLoading}
                  noOptionsMessage={() => 'No active flows found. Create and activate a flow in Onboarding → Flows.'}
                  styles={{ container: (base) => ({ ...base, width: '100%' }) }}
                />
              </div>

              <div style={{ marginBottom: 20 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#525b66', marginBottom: 5 }}>
                  Joining Date <span style={{ color: '#f75891' }}>*</span>
                </label>
                <input
                  type="date"
                  style={{ width: '100%', padding: '9px 12px', border: '1px solid #e4e9f0', borderRadius: 8, fontSize: 13, outline: 'none', fontFamily: 'inherit', background: '#fff' }}
                  value={onboardingForm.joiningDate}
                  min={new Date().toISOString().split('T')[0]}
                  onChange={e => setOnboardingForm(f => ({ ...f, joiningDate: e.target.value }))}
                />
              </div>

              <div style={{ marginBottom: 20 }}>
                <div style={{ marginBottom: 8 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a2e', marginBottom: 3 }}>
                    Additional documents{' '}
                    <span style={{ fontSize: 12, fontWeight: 400, color: '#8a9199' }}>(optional, per candidate)</span>
                  </div>
                  <div style={{ fontSize: 12, color: '#8a9199' }}>
                    Upload for this candidate only at initiate — not saved on the flow template.
                  </div>
                </div>

                {(() => {
                  const selectedFlow = onboardingFlows.find(f => f.id === onboardingForm.flowId);
                  const docCount = selectedFlow?.documents?.length ?? selectedFlow?.document_count ?? selectedFlow?.documents_count ?? 0;
                  if (!docCount) return null;
                  return (
                    <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', background: '#eff6ff', borderLeft: '3px solid #3b82f6', borderRadius: '0 8px 8px 0', padding: '10px 14px', marginBottom: 12, fontSize: 12, color: '#1e40af' }}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: 1 }}>
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <polyline points="14 2 14 8 20 8" />
                      </svg>
                      <span>
                        This flow includes <strong>{docCount} company document{docCount !== 1 ? 's' : ''}</strong> from the flow setup. Additional uploads below are added for this candidate only.
                      </span>
                    </div>
                  );
                })()}

                {onboardingAdditionalDocs.length > 0 && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 4 , marginBottom:'12px'}}>
                    {onboardingAdditionalDocs.map((doc, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: '#525b66', background: '#f4f5f7', borderRadius: 6, padding: '6px 10px' }}>
                        <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>📎 {doc.name}</span>
                        <select
                          style={{ fontSize: 11, padding: '2px 6px', border: '1px solid #e4e9f0', borderRadius: 4, background: '#fff' }}
                          value={doc.mode}
                          onChange={e => setOnboardingAdditionalDocs(prev => prev.map((d, j) => j === i ? { ...d, mode: e.target.value } : d))}
                        >
                          <option value="read">Read</option>
                          <option value="read & accept">Read &amp; Accept</option>
                        </select>
                        <button
                          style={{ fontSize: 13, color: '#f75891', background: 'none', border: 'none', cursor: 'pointer', padding: 0, lineHeight: 1, flexShrink: 0 }}
                          onClick={() => setOnboardingAdditionalDocs(prev => prev.filter((_, j) => j !== i))}
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                <div
                  style={{
                    border: `2px dashed ${dragActive ? '#f75891' : '#d1d5db'}`,
                    borderRadius: 10,
                    padding: '28px 20px',
                    textAlign: 'center',
                    cursor: 'pointer',
                    background: dragActive ? '#fff0f5' : '#fafafa',
                    transition: 'border-color 0.2s ease, background 0.2s ease',
                    marginBottom: onboardingAdditionalDocs.length > 0 ? 10 : 0,
                  }}
                  onClick={() => additionalDocInputRef.current?.click()}
                  onDragOver={e => { e.preventDefault(); setDragActive(true); }}
                  onDragEnter={e => { e.preventDefault(); setDragActive(true); }}
                  onDragLeave={e => { e.preventDefault(); setDragActive(false); }}
                  onDrop={async e => {
                    e.preventDefault();
                    setDragActive(false);
                    const files = Array.from(e.dataTransfer.files);
                    const uploaded = [];
                    for (const file of files) {
                      const fd = new FormData();
                      fd.append('file', file);
                      fd.append('bucket', 'org');
                      fd.append('detail', `${(file.size / 1024).toFixed(1)} KB · for this candidate only`);
                      fd.append('badge', 'candidate');
                      fd.append('meta_data', JSON.stringify({ candidate_specific: true }));
                      const res = await dispatch(uploadDocument(fd));
                      if (res?.success) {
                        const docId = res?.data?.id ?? res?.data?.data?.id ?? null;
                        uploaded.push({ id: docId, name: file.name, mode: 'read' });
                      }
                    }
                    setOnboardingAdditionalDocs(prev => [...prev, ...uploaded]);
                  }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
                    <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8a9199" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="16 16 12 12 8 16" />
                        <line x1="12" y1="12" x2="12" y2="21" />
                        <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
                      </svg>
                    </div>
                    <span style={{ fontSize: 13, color: '#525b66', fontWeight: 500 }}>Upload additional document</span>
                  </div>
                  <input
                    ref={additionalDocInputRef}
                    type="file"
                    multiple
                    style={{ display: 'none' }}
                    onChange={async (e) => {
                      const files = Array.from(e.target.files);
                      const uploaded = [];
                      for (const file of files) {
                        const fd = new FormData();
                        fd.append('file', file);
                        fd.append('bucket', 'org');
                        fd.append('detail', `${(file.size / 1024).toFixed(1)} KB · for this candidate only`);
                        fd.append('badge', 'candidate');
                        fd.append('meta_data', JSON.stringify({ candidate_specific: true }));
                        const res = await dispatch(uploadDocument(fd));
                        if (res?.success) {
                          const docId = res?.data?.id ?? res?.data?.data?.id ?? null;
                          uploaded.push({ id: docId, name: file.name, mode: 'read' });
                        }
                      }
                      setOnboardingAdditionalDocs(prev => [...prev, ...uploaded]);
                      e.target.value = '';
                    }}
                  />
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button
                style={{ padding: '9px 18px', borderRadius: 8, border: '1px solid #e4e9f0', background: '#fff', fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit', color: '#525b66' }}
                onClick={() => setOnboardingModalOpen(false)}
              >
                Cancel
              </button>
              <button
                style={{ padding: '9px 18px', borderRadius: 8, border: '1px solid #f75891', background: '#f75891', fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit', color: '#fff', opacity: onboardingLoading ? 0.6 : 1 }}
                disabled={onboardingLoading || !onboardingForm.flowId || !onboardingForm.joiningDate}
                onClick={async () => {
                  setOnboardingLoading(true);
                  const res = await dispatch(initiateOnboarding({
                    flow_id: onboardingForm.flowId,
                    candidate_id: candidateId,
                    joining_date: onboardingForm.joiningDate,
                    channel: 'email',
                    job_id: jobId,
                    additional_document_ids: onboardingAdditionalDocs.map(d => d.id),
                    additional_document_modes: Object.fromEntries(onboardingAdditionalDocs.map(d => [d.id, d.mode || 'read'])),
                  }));
                  setOnboardingLoading(false);
                  if (res) {
                    setOnboardingModalOpen(false);
                    setOnboardingAdditionalDocs([]);
                    showSnack('Onboarding initiated successfully!', 'success');
                    window.location.reload();
                  } else {
                    showSnack('Failed to initiate onboarding.', 'error');
                  }
                }}
              >
                {onboardingLoading ? 'Initiate onboarding..' : 'Initiate onboarding'}
              </button>
            </div>
          </div>
        </div>
      )}
      <ApplyStageModal
        isOpen={isOpen}
        setIsOpen={() => setIsOpen(false)}
        selectAssignedStage={selectAssignedStage}
        jobId={jobId}
        candidateId={candidateId}
        loading={stageLoading}
        assignProgress={assignProgress}
        preselectStage={preselectStage}
        stagePermissions={stagePermissionMap}
      />
      {/* ── Onboarding Request Changes Modal ─────────────────────── */}
      {onboardingCommentModal.open && (
        <div
          style={{ position: 'fixed', inset: 0, background: 'rgba(26,26,46,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1200, padding: 16 }}
          onClick={() => setOnboardingCommentModal((m) => ({ ...m, open: false }))}
        >
          <div
            style={{ background: '#fff', borderRadius: 14, padding: 24, width: '100%', maxWidth: 420, boxShadow: '0 8px 40px rgba(26,26,46,0.18)' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: '#1a1a2e' }}>Request Changes</h3>
              <img src="/images/close-icon.svg" alt="Close" style={{ cursor: 'pointer', width: 18, height: 18 }} onClick={() => setOnboardingCommentModal((m) => ({ ...m, open: false }))} />
            </div>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#525b66', display: 'block', marginBottom: 6 }}>Message to the candidate</label>
            <textarea
              autoFocus
              rows={4}
              style={{ width: '100%', padding: '9px 12px', border: '1px solid #e4e9f0', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', outline: 'none', resize: 'vertical', boxSizing: 'border-box' }}
              placeholder="Describe what needs to be corrected…"
              value={onboardingCommentModal.value}
              onChange={(e) => setOnboardingCommentModal((m) => ({ ...m, value: e.target.value }))}
            />
            <div style={{ display: 'flex', gap: 10, marginTop: 16, justifyContent: 'flex-end' }}>
              <button style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #e4e9f0', background: '#fff', fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit', color: '#525b66', minWidth: 80 }} onClick={() => setOnboardingCommentModal((m) => ({ ...m, open: false }))}>Cancel</button>
              <button style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #f75891', background: '#f75891', fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit', color: '#fff', minWidth: 80 }} onClick={handleSubmitOnboardingRequestChanges}>Send</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Onboarding Candidate Progress Modal ───────────────────── */}
      {onboardingViewModal.open && (
        <div
          style={{ position: 'fixed', inset: 0, background: 'rgba(26,26,46,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, padding: 16 }}
          onClick={() => setOnboardingViewModal({ open: false, runId: null, data: null, loading: false })}
        >
          <div
            style={{ background: '#fff', borderRadius: 14, padding: 28, width: '100%', maxWidth: 540, boxShadow: '0 8px 40px rgba(26,26,46,0.18)', maxHeight: '80vh', overflowY: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: '#1a1a2e' }}>Candidate Progress</h3>
              <img src="/images/close-icon.svg" alt="Close" style={{ cursor: 'pointer', width: 18, height: 18 }} onClick={() => setOnboardingViewModal({ open: false, runId: null, data: null, loading: false })} />
            </div>
            {onboardingViewModal.loading ? (
              <div style={{ display: 'flex', justifyContent: 'center', padding: '40px 0' }}>
                <div className="spinner-border" role="status" />
              </div>
            ) : onboardingViewModal.data ? (
              <div>
                <div style={{ padding: '12px 14px', background: '#f4f5f7', borderRadius: 8, marginBottom: 16 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: '#1a1a2e' }}>{onboardingViewModal.data.run?.candidate_name || '—'}</div>
                  <div style={{ fontSize: 12, color: '#8a9199', marginTop: 2 }}>{onboardingViewModal.data.run?.email}</div>
                  <div style={{ display: 'flex', gap: 16, marginTop: 8, flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 12, color: '#525b66' }}>Flow: <strong>{onboardingViewModal.data.flow_name || '—'}</strong></span>
                    <span style={{ fontSize: 12, color: '#525b66' }}>Job: <strong>{onboardingViewModal.data.run?.job_title || '—'}</strong></span>
                    <span style={{ fontSize: 12, color: '#525b66' }}>Joining: <strong>{onboardingViewModal.data.run?.joining_date ? new Date(onboardingViewModal.data.run.joining_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }) : '—'}</strong></span>
                  </div>
                </div>
                {(() => {
                  const phases = onboardingViewModal.data.phases || [];
                  const completed = phases.filter((p) => p.status === 'completed').length;
                  const pct = phases.length ? Math.round((completed / phases.length) * 100) : 0;
                  return (
                    <div style={{ marginBottom: 16 }}>
                      <div style={{ fontSize: 12, fontWeight: 600, color: '#525b66', marginBottom: 8 }}>Overall Progress</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ flex: 1, height: 8, borderRadius: 99, background: '#e4e9f0', overflow: 'hidden' }}>
                          <div style={{ width: `${pct}%`, height: '100%', background: '#f75891', borderRadius: 99 }} />
                        </div>
                        <span style={{ fontSize: 13, fontWeight: 600, color: '#f75891' }}>{pct}%</span>
                      </div>
                    </div>
                  );
                })()}
                <div style={{ marginBottom: 8, fontSize: 12, fontWeight: 600, color: '#525b66' }}>Phases</div>
                {(onboardingViewModal.data.phases || []).map((s, idx) => (
                  <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: '1px solid #f0f0f0' }}>
                    <div style={{ width: 28, height: 28, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: s.status === 'completed' ? '#f75891' : s.status === 'in_progress' ? '#3b82f6' : '#e4e9f0', flexShrink: 0 }}>
                      {s.status === 'completed' ? (
                        <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
                          <path d="M2 7l3.5 3.5L12 3" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      ) : (
                        <span style={{ fontSize: 11, color: s.status === 'in_progress' ? '#fff' : '#8a9199', fontWeight: 600 }}>{idx + 1}</span>
                      )}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: 500, color: '#1a1a2e' }}>{s.label}</div>
                    </div>
                    <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 99, background: s.status === 'completed' ? '#dcfce7' : s.status === 'in_progress' ? '#dbeafe' : '#f3f4f6', color: s.status === 'completed' ? '#16a34a' : s.status === 'in_progress' ? '#1d4ed8' : '#6b7280' }}>
                      {s.status === 'completed' ? 'Done' : s.status === 'in_progress' ? 'In Progress' : 'Pending'}
                    </span>
                  </div>
                ))}
                {(onboardingViewModal.data.forms || []).length > 0 && (
                  <>
                    <div style={{ marginTop: 16, marginBottom: 8, fontSize: 12, fontWeight: 600, color: '#525b66' }}>Forms</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                      {onboardingViewModal.data.forms.map((f, idx) => {
                        const isFormOpen = expandedOnboardingForms[f.form_id] !== false;
                        const responseEntries = Object.entries(f.responses || {});
                        return (
                          <div key={idx} style={{ border: '1px solid #e4e9f0', borderRadius: 10, overflow: 'hidden' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '11px 14px', cursor: 'pointer', background: isFormOpen ? '#fafbfc' : '#fff' }} onClick={() => toggleOnboardingForm(f.form_id)}>
                              <div style={{ flex: 1 }}>
                                <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a2e' }}>{f.form_name}</div>
                                {f.completed_at && <div style={{ fontSize: 11, color: '#8a9199', marginTop: 2 }}>Completed {new Date(f.completed_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</div>}
                              </div>
                              <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 99, background: f.status === 'completed' ? '#dcfce7' : f.status === 'in_progress' ? '#dbeafe' : '#f3f4f6', color: f.status === 'completed' ? '#16a34a' : f.status === 'in_progress' ? '#1d4ed8' : '#6b7280' }}>
                                {f.status === 'completed' ? 'Done' : f.status === 'in_progress' ? 'In Progress' : 'Not Started'}
                              </span>
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8a9199" strokeWidth="2" style={{ flexShrink: 0, transform: isFormOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
                                <polyline points="6 9 12 15 18 9" />
                              </svg>
                            </div>
                            {isFormOpen && (
                              <div style={{ background: '#f8f9fb', padding: '10px 14px 12px', borderTop: '1px solid #eef0f3' }}>
                                {responseEntries.length === 0 ? (
                                  <div style={{ fontSize: 12, color: '#8a9199', fontStyle: 'italic' }}>No responses yet.</div>
                                ) : (
                                  responseEntries.map(([label, value]) => {
                                    const isFile = value && typeof value === 'object' && value.file_url;
                                    return (
                                      <div key={label} style={{ display: 'flex', gap: 8, padding: '6px 0', borderBottom: '1px solid #eef0f3', flexWrap: 'wrap', alignItems: 'center' }}>
                                        <span style={{ fontSize: 12, color: '#8a9199', minWidth: 140, flexShrink: 0 }}>{label}</span>
                                        {isFile ? (
                                          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                            <span style={{ fontSize: 12, color: '#1a1a2e', fontWeight: 500, wordBreak: 'break-all' }}>{value.file_name}</span>
                                            <a href={value.file_url} download={value.file_name} target="_blank" rel="noreferrer" style={{ color: '#f75891', flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                                              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                                <polyline points="7 10 12 15 17 10" />
                                                <line x1="12" y1="15" x2="12" y2="3" />
                                              </svg>
                                            </a>
                                          </div>
                                        ) : (
                                          <span style={{ fontSize: 12, color: '#1a1a2e', fontWeight: 500, wordBreak: 'break-all' }}>{String(value)}</span>
                                        )}
                                      </div>
                                    );
                                  })
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
                {(onboardingViewModal.data.documents || []).length > 0 && (
                  <>
                    <div style={{ marginTop: 16, marginBottom: 8, fontSize: 12, fontWeight: 600, color: '#525b66' }}>Documents</div>
                    {onboardingViewModal.data.documents.map((d, idx) => (
                      <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: '1px solid #f0f0f0' }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 13, fontWeight: 500, color: '#1a1a2e' }}>{d.name}</div>
                        </div>
                        <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 99, textTransform: 'capitalize', background: d.status === 'completed' || d.status === 'accepted' ? '#dcfce7' : d.status === 'pending' ? '#fef3c7' : d.status === 'rejected' ? '#fee2e2' : '#f3f4f6', color: d.status === 'completed' || d.status === 'accepted' ? '#16a34a' : d.status === 'pending' ? '#d97706' : d.status === 'rejected' ? '#dc2626' : '#6b7280' }}>
                          {d.status}
                        </span>
                      </div>
                    ))}
                  </>
                )}
              </div>
            ) : (
              <div style={{ textAlign: 'center', padding: '20px', color: '#8a9199', fontSize: 13 }}>No data available</div>
            )}
            {!onboardingViewModal.loading && onboardingViewModal.data?.run?.status === 'in_review' && (
              <div style={{ display: 'flex', gap: 10, marginTop: 20, paddingTop: 16, borderTop: '1px solid #e4e9f0' }}>
                <button style={{ flex: 1, padding: '9px 18px', borderRadius: 8, border: '1px solid #e4e9f0', background: '#fff', fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit', color: '#525b66' }} onClick={() => handleOnboardingRequestChanges(onboardingViewModal.runId)}>
                  Request Changes
                </button>
                <button style={{ flex: 1, padding: '9px 18px', borderRadius: 8, border: '1px solid #22c55e', background: '#22c55e', fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit', color: '#fff' }} onClick={() => handleCompleteOnboardingReview(onboardingViewModal.runId)}>
                  Mark Completed
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* LIGHTBOX FOR PROCTORING IMAGES */}
      <Lightbox
        openBox={openProctorLightbox}
        image={selectedProctorImage}
        closeBox={() => setOpenProctorLightbox(false)}
        showPrev={selectedProctorIndex > 0}
        showNext={selectedProctorIndex < cheatingFrames.length - 1}
        onPrev={() => {
          if (selectedProctorIndex > 0) {
            const newIndex = selectedProctorIndex - 1;
            setSelectedProctorIndex(newIndex);
            setSelectedProctorImage(cheatingFrames[newIndex].image_url);
          }
        }}
        onNext={() => {
          if (selectedProctorIndex < cheatingFrames.length - 1) {
            const newIndex = selectedProctorIndex + 1;
            setSelectedProctorIndex(newIndex);
            setSelectedProctorImage(cheatingFrames[newIndex].image_url);
          }
        }}
      />
    </div>
  );
};

export default CandidateProfile;
